import React, { useEffect } from 'react';
import mixpanel from 'mixpanel-browser';

import { Grid } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import { HorizontalBarCard, AreaChartRatioCard } from '../../../HOC/Cards';
import { ViewDemoButton } from '../../../Components/Buttons';
import { ParsedGuest } from '../../../../interfaces/idashboard';
import { GuestDashboardPropTypes } from '../../../../interfaces/iproptypes';
import { useHighlight } from 'src/utils/hooks';
import ConfirmUnlockRegionModal from 'src/App/Modals/ConfirmUnlockRegionModal';
import RedirectModal from 'src/App/Modals/RedirectModalDashboard';

mixpanel.init('0c9d3451de8e0a1a2f21ec23b05c2063');

const GuestsDashboard = ({
  graph,
  getGraphData,
  isUserAllowed,
  search,
  handleOnSampleClick,
  district,
  city,
  country,
  isUserVerified,
  rateLimitAlert,
  setIsEmailVerifyModalOpen,
  user,
  showSearchCreditDeductWarningModal,
  setShowSearchCreditDeductWarningModal,
  getMarkers,
  isLoggedIn,
  userTailorMarketAccess
}: GuestDashboardPropTypes) => {
  const { removeHighlightElement } = useHighlight();

  useEffect(() => {
    mixpanel.track('visitGuestsTab');
  }, []);

  useEffect(() => {
    removeHighlightElement('searchBar');
  }, []);

  let isDisabled: boolean = !isUserAllowed;

  if (!graph.loading && (!graph.data || !graph.data.guest)) {
    graph.data.guest = {};
    graph.data.guest.history = [];
    graph.data.guest.countries = {};
    graph.data.guest.cities = {};
    graph.data.guest.Languages = {};
  }

  useEffect(() => {
    // to handle the edge case when coming to this page from "/"
    //after comming from a page like "localhost:3000/" the distict in url params is undefined
    //and the location is being updated after coming to this so
    //so reloading the page so it will take the updated location from the url
    if (!district) {
      if(window.location.pathname === '/airbnb-data' || window.location.pathname === '/airbnb-data?guests=true'){
        window.location.href = '/airbnb-data/united-kingdom/0/the city of brighton and hove?guests=true';
      }else{
        window.location.href = window.location + '?guests=true';
      }
    }
  }, []);

  useEffect(() => {
    !search.loading && getGraphData();
  }, [search]);

  return (
    <>
      {/* {isLoggedIn && <RedirectModal dashboardName='Guests Tab' fixDate={10} />} */}
      <Grid container item direction="column" spacing={2} style={{ position: 'relative' }}>
        <Grid item xs={12} md={12} lg={12}>
          {graph.loading ? (
            <Skeleton variant="rect" animation="wave" width="100%" height={150} />
          ) : (
            <AreaChartRatioCard
              title="Domestic and International Guests"
              date={graph.data.area_info.updatedDate}
              data={graph.data.guest.history}
              tooltipContent={'Percentage of Domestic and International Guests booking'}
              isDisabled={isDisabled}
              handleOnSampleClick={handleOnSampleClick}
              userTailorMarketAccess={userTailorMarketAccess}
            />
          )}
        </Grid>

        <Grid item xs={12} md={12} lg={12}>
          {graph.loading ? (
            <Skeleton variant="rect" animation="wave" width="100%" height={450} />
          ) : (
            <HorizontalBarCard
              title="International guest origin top countries"
              data={parseGuest(graph.data.guest.countries as string)}
              color="#58C0A9"
              unit="%"
              isDisabled={isDisabled}
              handleOnSampleClick={handleOnSampleClick}
              userTailorMarketAccess={userTailorMarketAccess}
            />
          )}
        </Grid>

        <Grid item xs={12} md={12} lg={12}>
          {graph.loading ? (
            <Skeleton variant="rect" animation="wave" width="100%" height={450} />
          ) : (
            <HorizontalBarCard
              title="Guest origin top cities"
              data={parseGuest(graph.data.guest.cities)}
              color="#758afe"
              unit="%"
              isDisabled={isDisabled}
              handleOnSampleClick={handleOnSampleClick}
              userTailorMarketAccess={userTailorMarketAccess}
            />
          )}
        </Grid>

        <Grid item xs={12} md={12} lg={12}>
          {graph.loading ? (
            <Skeleton variant="rect" animation="wave" width="100%" height={450} />
          ) : (
            <HorizontalBarCard
              title="Guest language speaking"
              data={parseGuest(graph.data.guest.Languages)}
              color="#58C0A9"
              unit="%"
              isDisabled={isDisabled}
              handleOnSampleClick={handleOnSampleClick}
              userTailorMarketAccess={userTailorMarketAccess}
            />
          )}
        </Grid>
        {!isUserVerified && rateLimitAlert && (
          <ViewDemoButton
            handleClick={() => setIsEmailVerifyModalOpen(true)}
            buttonText="You have used up all 3 free searches. Please verify your email to get free searches."
            topOffsetMobile="3%"
          />
        )}
      </Grid>

      {user && user.userDescription !== 'Trial' && (
        <ConfirmUnlockRegionModal
          open={!isUserAllowed && showSearchCreditDeductWarningModal}
          onConfirm={() => {
            setShowSearchCreditDeductWarningModal(false);
            getMarkers(true, 1);
          }}
          onCancel={() => setShowSearchCreditDeductWarningModal(false)}
          message="Would you like to unlock this market? (Please note this will deduct 1 market credit.)"
        />
      )}
    </>
  );
};

const parseGuest = (input: string): ParsedGuest => {
  if (isEmpty(input)) {
    return {} as ParsedGuest;
  }
  return JSON.parse(input);
};

const isEmpty = (obj: string): boolean => {
  if (!obj) {
    return true;
  }
  return Object.keys(obj).length <= 0;
};

export default GuestsDashboard;
